import { SET_DEFAULT_SORT_ORDER, SET_TABLE_DATA, SORT_TABLE_DATA } from "../actionTypes";

export const setTableData = (data: any[]) => ({
    type: SET_TABLE_DATA,
    payload: data,
});

export const sortTableData = (key: string) => ({
    type: SORT_TABLE_DATA,
    payload: key,
});

export const setDefaultSortOrder = (key: string, order: 'asc' | 'desc') => ({
    type: SET_DEFAULT_SORT_ORDER,
    payload: { key, order },
});
